import React , {Component } from 'react';
import AUX from '../../../hoc/Aux_';
import { Link } from 'react-router-dom';
import {fetchCms} from '../../../api/cms';
import convert from 'htmr';

class Contact extends Component{

  constructor(props) {
    super(props);
    this.state = {
      title:"",
      description: ""
    }
  }

  componentWillMount(){
    fetchCms("kontak")
    .then(response => {
        if (response != null) {
          response.data.map((e)=>{
            this.setState({title: e.title, description:e.description})
          })
        }
      })
      .catch(error => {
      });
  }

    render(){
        return(
            <AUX>
                <section className="pt-2 bg-dark" id="contact">
                    <div className="container">
                        <div className="row justify-content-center pt-2">
                            <div className="col-md-8">
                                <div className="text-left">
                                    <h4 className="section-title text-white pt-2">{this.state.title}</h4>
                                    {convert(this.state.description)}
                                </div>
                            </div>
                        </div>

                        <div className="row mt-5 pt-2 pb-2">
                            <div className="col-md-12">
                                <div className="text-white footer-alt">
                                    <div className="float-left">
                                        <p className="copyright-desc pb-0">{(new Date().getFullYear())} © Badan Informasi Geospasial</p>
                                    </div>
                                    <div className="float-right">
                                        <ul className="list-inline social pb-0">
                                            <li className="list-inline-item pl-2"><Link to="https://www.facebook.com/infogeospasial/" className="text-white"><i className="mdi mdi-facebook"></i></Link></li>
                                            <li className="list-inline-item pl-2"><Link to="https://twitter.com/infogeospasial" className="text-white"><i className="mdi mdi-twitter"></i></Link></li>
                                            <li className="list-inline-item pl-2"><Link to="https://www.instagram.com/infogeospasial/" className="text-white"><i className="mdi mdi-instagram"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
           </AUX>
        );
    }
}

export default Contact;
